<template>
  <b-form @submit.prevent="save">
    <SettingsTitleBar sub="Profile" />
      <b-form-group label="First Name:" label-for="first_name">
        <b-form-input v-model="form.first_name" id="first_name" placeholder="Enter first name">
        </b-form-input>
      </b-form-group>
      <b-form-group label="Last Name:" label-for="last_name">
        <b-form-input v-model="form.last_name" id="last_name" placeholder="Enter last name">
        </b-form-input>
      </b-form-group>
      <b-form-group label="Email:" label-for="email">
        <b-form-input v-model="form.email" id="email" type="email" placeholder="Enter email">
        </b-form-input>
      </b-form-group>
      <b-form-group label="Job Role:" label-for="job_role">
          <b-form-select v-model="form.job_role">
          <option value="">(select one)</option>
          <option>Owner/Founder</option>
          <option>Office Manager/Admin</option>
          <option>Designer</option>
          <option>Marketing</option>
          <option>HR</option>
          <option>Sales</option>
          <option>Other</option>
       </b-form-select>
      </b-form-group>
      <b-form-group v-for="{key, label} in personalVars" :key="key" :label="label" :label-for="key">
        <b-form-input v-model="info[key]" type="text" placeholder="">
        </b-form-input>
      </b-form-group>

    <div v-if="!isStaff && userTeams.length > 1">
      <b-modal id="leave-team-modal" title="Leave current team" centered @ok="leaveCurrentTeam">
        <div>Are you sure you want to leave "{{ team.name }}"?</div>
      </b-modal>

      <b-button class="mt-3" size="sm" variant="outline-secondary" v-b-modal.leave-team-modal>
      <i class="fas fa-sign-out-alt" /> Leave {{ team.name }}
    </b-button>
    </div>

    </b-form>
  </template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {form: {first_name: '', last_name: '', email: '', job_role: ''}, info: {}, saving: false}
  },
  watch: {
    user() { this.copyFromStore(); }
  },
  mounted() { this.copyFromStore(); },
  computed: mapGetters(['flags', 'user', 'personalVars', 'isStaff', 'userTeams', 'team']),
  methods: {
    ...mapActions(['updateProfile', 'removeFromTeam']),
    ...mapMutations(['removeTeamFromUserTeams']),
    copyFromStore() {
      for (let k in this.form) {
        this.form[k] = this.user[k];
      }
      Object.assign(this.info, this.user.personal_info||{});
    },
    async save() {
      this.saving = true;
      await this.updateProfile({...this.form, personal_info: this.info});
      this.saving = false;
      this.$router.push('/dashboard/settings');
    },
    async leaveCurrentTeam() {
      const teamRemovedFromID = this.team.id;

      await this.removeFromTeam(this.user);

      // After removing, current team will be reloaded - at this point teamRemovedFromID !== this.team.id
      this.removeTeamFromUserTeams(teamRemovedFromID);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/EditProfile.vue